import { ReferenceValueDelimiter } from '../types/types';

// Form multi-select reference values are `;`-delimited; filters and single-select stay `,`.
export const getReferenceValueDelimiter = (
  isFormInput: boolean | undefined,
  multiSelect: boolean | undefined
): ReferenceValueDelimiter => (isFormInput && multiSelect ? ';' : ',');
